module.exports = __webpack_public_path__ + "img/index_sample.4dcd4d65.png";